import styles from "./App.module.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import SignIn from "./screens/SignIn/SignIn";
import Register from "./screens/Register/Register";
import Verification from "./screens/Verification/Verification";
import Home from "./screens/Home/Home";
import Payment from "./screens/Payment/Payment";
import PickupAssigned from "./screens/PickupAssigned/PickupAssigned";
import Account from "./screens/Account/Account";
import Profile from "./screens/Profile/Profile";
import Contact from "./screens/Contact/Contact";
import Terms from "./screens/Terms/Terms";
import MyDeliveries from "./screens/MyDeliveries/MyDeliveries";
import NewDeliveries from "./screens/NewDeliveries/NewDeliveries";
import CourierInfo from "./screens/CourierInfo/CourierInfo";
import ConfirmInfo from "./screens/ConfirmInfo/ConfirmInfo";
import PickupLocation from "./screens/PickupLocation/PickupLocation";
import DropLocation from "./screens/DropLocation/DropLocation";
import TrackDelivery from "./screens/TrackDelivery/TrackDelivery";
import DeliveryInfo from "./screens/DeliveryInfo/DeliveryInfo";
import Earnings from "./screens/Earnings/Earnings";

import CourierMeasurement from "./screens/CourierMeasurement/CourierMeasurement";

function App() {
  return (
    <div className={styles.container}>
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/my-account" component={Account} />
          <Route path="/my-profile" component={Profile} />
          <Route path="/my-deliveries" component={MyDeliveries} />
          <Route path="/track-delivery/:id" component={TrackDelivery} />
          <Route path="/new-deliveries" component={NewDeliveries} />
          <Route path="/delivery-info/:id" component={DeliveryInfo} />
          <Route path="/pickup-location" component={PickupLocation} />
          <Route path="/drop-location" component={DropLocation} />
          <Route path="/courier-info" component={CourierInfo} />
          <Route path="/confirm-info" component={ConfirmInfo} />
          <Route path="/payment-modes" component={Payment} />
          <Route path="/pickup-assigned" component={PickupAssigned} />
          <Route path="/login" component={SignIn} />
          <Route path="/register" component={Register} />
          <Route path="/verification" component={Verification} />
          <Route path="/contact-us" component={Contact} />
          <Route path="/terms" component={Terms} />
          <Route path="/earnings" component={Earnings} />
          <Route path="/courier-measurement" component={CourierMeasurement} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
